import { lazy, Suspense, useEffect, useState } from 'react';

import {
  LocalStorageKey,
  LocalStorageUtil,
} from '../../utils/LocalStorageUtil';

const COOKIE_MODAL_IDLE_TIMEOUT_MS = 2000;
const COOKIE_MODAL_FALLBACK_DELAY_MS = 1000;

const CookieModal = lazy(() =>
  import('./CookieModal').then((m) => ({ default: m.CookieModal })),
);

export const CookieModalGate = () => {
  const [shouldLoadModal, setShouldLoadModal] = useState(false);

  useEffect(() => {
    if (LocalStorageUtil.get(LocalStorageKey.COOKIE_BANNER_CONSENT)) {
      return;
    }

    if (typeof requestIdleCallback === 'function') {
      const idleCallbackId = requestIdleCallback(
        () => setShouldLoadModal(true),
        { timeout: COOKIE_MODAL_IDLE_TIMEOUT_MS },
      );

      return () => cancelIdleCallback(idleCallbackId);
    }

    const timeoutId = window.setTimeout(
      () => setShouldLoadModal(true),
      COOKIE_MODAL_FALLBACK_DELAY_MS,
    );

    return () => window.clearTimeout(timeoutId);
  }, []);

  return shouldLoadModal ? (
    <Suspense fallback={null}>
      <CookieModal />
    </Suspense>
  ) : null;
};
